var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-lines */
import React, { useMemo, useState } from 'react';
import { getSingleFieldValue, } from '@connectrn/ds-ui-base';
import { CFCheckboxField, CFPasswordField, CFRadioField, CFSelectField, CFSwitchField, CFTextField, CFToggleButtonField, } from '../../components';
import { commonAttrs } from '../../utils';
import { CFFormFieldElements } from './FormField.styles';
import { FormFieldCaption } from './components/FormFieldCaption';
export const CFFormField = (_a) => {
    var { caption, captionRight, errors, fieldProps, fieldType = 'text', id, label, name, onChange, validated, value } = _a, rest = __rest(_a, ["caption", "captionRight", "errors", "fieldProps", "fieldType", "id", "label", "name", "onChange", "validated", "value"]);
    const { ControlWrapper, Label, Root } = CFFormFieldElements;
    const [hasErrors, setHasErrors] = useState(false);
    const showCaption = !!(errors || caption || captionRight);
    const renderFormControl = () => {
        let validationState = 'default';
        if (validated)
            validationState = 'valid';
        else if (errors === true)
            validationState = 'error';
        else if (errors && errors.length > 0)
            validationState = 'error';
        switch (fieldType) {
            case 'checkbox':
                return (React.createElement(CFCheckboxField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: value }, fieldProps)));
            case 'radio':
                return (React.createElement(CFRadioField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: value }, fieldProps)));
            case 'switch':
                return (React.createElement(CFSwitchField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: value }, fieldProps)));
            case 'select':
                return (React.createElement(CFSelectField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: value }, fieldProps)));
            case 'toggle-button':
                return (React.createElement(CFToggleButtonField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: value }, fieldProps)));
            case 'password':
                return (React.createElement(CFPasswordField, Object.assign({ name: name, onChange: onChange, validationState: validationState, value: getSingleFieldValue(value || '') }, fieldProps)));
            case 'text':
            default:
                return (React.createElement(CFTextField, Object.assign({ id: id, name: name, onChange: onChange, validationState: validationState, value: getSingleFieldValue(value || '') }, fieldProps)));
        }
    };
    useMemo(() => {
        if (errors === true) {
            setHasErrors(true);
            return;
        }
        if (errors && errors.length > 0) {
            setHasErrors(true);
            return;
        }
        setHasErrors(false);
        return;
    }, [errors]);
    return (React.createElement(Root, Object.assign({}, commonAttrs(rest)),
        label && (React.createElement(Label, { hasErrors: hasErrors, htmlFor: id, validated: validated }, label)),
        React.createElement(ControlWrapper, null, renderFormControl()),
        showCaption && (React.createElement(FormFieldCaption, { caption: caption, captionRight: captionRight, errors: errors, id: id, hasErrors: hasErrors, name: name, validated: validated }))));
};
